/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RansomwareRecoveryEdrVendorEnum } from './ransomwareRecoveryEdrVendorEnum';
import { RansomwareRecoveryDeploymentStatesEnum } from './ransomwareRecoveryDeploymentStatesEnum';
import { RansomwareRecoveryProvisionModeEnum } from './ransomwareRecoveryProvisionModeEnum';


export interface OperatorRwrActivationDetails { 
    /**
     * The organization ID for the vLCR provider.
     */
    vlcr_org_id?: string;
    /**
     * The cloud provider for the vLCR service.
     */
    vlcr_cloud_provider?: string;
    /**
     * The region for the vLCR service.
     */
    vlcr_region?: string;
    /**
     * VLCR deployment ID associated with this RWR activation.
     */
    vlcr_deployment_id?: string;
    /**
     * The organization ID for the EDR service.
     */
    edr_org_id?: string;
    /**
     * The region for the EDR cloud instance.
     */
    edr_region?: string;
    edr_vendor?: RansomwareRecoveryEdrVendorEnum;
    provision_mode?: RansomwareRecoveryProvisionModeEnum;
    /**
     * The ID for the ransomware recovery deployment.
     */
    ransomware_recovery_deployment_id?: string;
    /**
     * The user who requested activation.
     */
    activation_requested_by?: string;
    /**
     * The timestamp when activation was requested.
     */
    activation_requested_ts?: Date;
    activation_status?: RansomwareRecoveryDeploymentStatesEnum;
    /**
     * The task ID for the activation request.
     */
    activation_task_id?: string;
    /**
     * The user who requested deactivation.
     */
    deactivation_requested_by?: string;
    /**
     * The timestamp when deactivation was requested.
     */
    deactivation_requested_ts?: Date;
    /**
     * The task ID for the deactivation request.
     */
    deactivation_task_id?: string;
    /**
     * The organization name associated with this deployment.
     */
    org_name?: string;
    /**
     * Id generated for org and EDR region pair
     * @deprecated
     */
    activation_group_id?: string;
    activation_request_list?: Array<object>;
    activation_response_list?: Array<object>;
    activation_status_request_list?: Array<object>;
    activation_status_response_list?: Array<object>;
    api_error_list?: Array<object>;
    cb_api_key_creation_request_list?: Array<object>;
    cb_api_key_creation_response_list?: Array<object>;
    /**
     * Created timestamp in UTC
     */
    created_timestamp?: Date;
    deactivation_request_list?: Array<object>;
    deactivation_response_list?: Array<object>;
    /**
     * RWR Activation API version
     * @deprecated
     */
    deployment_version?: string;
    irr_reconfigure_request_list?: Array<object>;
    irr_reconfigure_response_list?: Array<object>;
    /**
     * Updated timestamp in UTC
     */
    updated_timestamp?: Date;
}
export namespace OperatorRwrActivationDetails {
}


